/** biome-ignore-all lint/style/useNamingConvention: allow snake case */
import {appsignal} from '~/common/global';

type Severity = 'trace' | 'debug' | 'info' | 'log' | 'warn' | 'error';

declare global {
  interface Window {
    app_signal_api_key?: string;
    app_signal_enabled?: string;
  }
}

// biome-ignore lint/suspicious/noExplicitAny: allow any
export async function logger(message: string, severity?: Severity, attributes?: any) {
  const loggingApiKey = window.app_signal_api_key;
  if (loggingApiKey && window.app_signal_enabled === 'true') {
    const url = `https://appsignal-endpoint.net/logs/json?api_key=${loggingApiKey}`;
    const ndjson = {
      timestamp: new Date().toISOString(),
      message,
      attributes,
      hostname: window.location.hostname,
      severity: severity || 'info',
    };
    try {
      await fetch(url, {
        method: 'POST',
        mode: 'no-cors',
        credentials: 'include',
        cache: 'no-cache',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(ndjson),
      });
    } catch (e) {
      if (e instanceof Error || e instanceof ErrorEvent) {
        appsignal.sendError(e);
      } else {
        evite.error('Could not log, error is not valid', e);
      }
      evite.error('Failed to log', e);
    }
  }
}
